export default __webpack_public_path__ + "static/construction-header-379a0fdfa88a6fdc7c895b79e866dd64.jpg";